import { OrganizationFeature } from './organization';
import { _DeepReadonlyArray } from 'utility-types/dist/mapped-types';

export enum UserOrganizationAffiliationType {
  Activity = 'Activity',
  Legacy = 'Legacy'
}

export interface IUserOrganization {
  name: string;
  id: string;
  isPrimary: boolean;
  features: OrganizationFeature[];
  affiliationType: UserOrganizationAffiliationType;
  subsidiariesHierarchy: ISubsidiariesOrganization;
  isSubsidiary?: boolean | null;
}

export interface ISubsidiariesOrganization {
  organizationId: string;
  organizationName: string;
  rank: number;
  parentOrganizationId: string | null;
  children: _DeepReadonlyArray<ISubsidiariesOrganization>;
  features: OrganizationFeature[];
}
